import axiosClient from 'config/axiosClient';

const _url = '/Api/StudentEvaluation';

const studentEvaluationService = {
    getEvaluationsForTeacher: (options: any) => {
        return axiosClient.post(_url + '/GetEvaluationsForTeacher', options);
    },
    export: (options: any) => {
        return axiosClient.post(_url + '/Export', options, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type':
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        });
    },

    getQuestionEvaluation: (options: any) => {
        return axiosClient.post(_url + '/GetQuestionEvaluation', options);
    },

    updateQuestionEvaluation: (data: any) => {
        return axiosClient.post(_url + '/UpdateQuestionEvaluation', data);
    },

    exportPracticeQuestion: (examId: string) => {
        return axiosClient.get(_url + `/ExportPracticeEvaluation?examId=${examId}`, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type':
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        });
    }
};
export default studentEvaluationService;